import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Subject } from 'rxjs';
import { KsefDashboardComponent } from './tabs/dashboard/dashboard.component';
import { PendingBatchesComponent } from './tabs/pending-batches/pending-batches.component';
import { ErrorsListComponent } from './tabs/errors-list/errors-list.component';
import { ValidationErrorsListComponent } from './tabs/validation-errors-list/validation-errors-list.component';
import { BatchSessionsListComponent } from './tabs/batch-sessions-list/batch-sessions-list.component';
import { KsefToolsComponent } from './tabs/tools/tools.component';
import { SyncStatusComponent } from './tabs/sync-status/sync-status.component';
import { NipVerificationComponent } from './tabs/nip-verification/nip-verification.component';

interface Tab {
  label: string;
  icon: string;
  badge?: string;
  badgeClass?: string;
}

/**
 * KSeF Admin Panel - Główny komponent
 * 
 * Zakładki:
 * 1. Dashboard - Statystyki wysyłek
 * 2. Pending Batches - Kolejka oczekujących faktur (BEZ sesji batch)
 * 3. Błędy Wysyłek - Faktury z błędami wysyłki do KSeF
 * 4. Błędy Walidacji - Faktury które nie przeszły walidacji PRZED wysyłką
 * 5. Sesje Batch - Historia sesji batch z pełną listą faktur
 * 6. Synchronizacja - Status synchronizacji userów
 * 7. Data Cleanup - Zarządzanie retencją logów
 * 8. Narzędzia - Usuwanie danych testowych
 */
@Component({
  selector: 'app-ksef-panel',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    KsefDashboardComponent,
    PendingBatchesComponent,
    ErrorsListComponent,
    ValidationErrorsListComponent,
    BatchSessionsListComponent,
    SyncStatusComponent,
    KsefToolsComponent,
    NipVerificationComponent
  ],
  templateUrl: './ksef-panel.component.html',
  styleUrls: ['./ksef-panel.component.scss']
})
export class KsefPanelComponent implements OnInit, OnDestroy {
  
  selectedTabIndex = 0;
  
  tabs: Tab[] = [
    { label: 'Pulpit', icon: 'tabler_outline:chart-line' },
    { label: 'Oczekujące faktury', icon: 'tabler_outline:clock' },
    { label: 'Logi', icon: 'tabler_outline:alert-circle', badge: 'PRIORYTET', badgeClass: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200' },
    { label: 'Błędy walidacji', icon: 'tabler_outline:file-alert' },
    { label: 'Sesje batch', icon: 'tabler_outline:database' },
    { label: 'Synchronizacja', icon: 'tabler_outline:refresh' },
    { label: 'Data Cleanup', icon: 'tabler_outline:trash' },
    { label: 'Narzędzia', icon: 'tabler_outline:tool' },
    { label: 'Weryfikacja NIP', icon: 'tabler_outline:id' }
  ];
  
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor() { }

  ngOnInit(): void {
    // Tab index z URL query params (opcjonalnie)
    const urlParams = new URLSearchParams(window.location.search);
    const tab = urlParams.get('tab');
    if (tab) {
      this.selectedTabIndex = parseInt(tab, 10);
    }
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  /**
   * Zmiana zakładki
   */
  selectTab(index: number): void {
    this.selectedTabIndex = index;
    // Opcjonalnie: Update URL bez przeładowania
    const url = new URL(window.location.href);
    url.searchParams.set('tab', index.toString());
    window.history.replaceState({}, '', url.toString());
  }
}

